var map = {
	"./culturebox.png": 626,
	"./france-2.png": 627,
	"./france-3.png": 628,
	"./france-4.png": 629,
	"./france-5.png": 630,
	"./france-tv.png": 631,
	"./franceinfo.png": 632,
	"./okoo.png": 633,
	"./slash.png": 634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 625;